import {
  ColumnBlockSchema,
  ColumnsBlockSchema,
} from '@blocksuite/affine-model';
import {
  BlockHtmlAdapterExtension,
  type BlockHtmlAdapterMatcher,
} from '@blocksuite/affine-shared/adapters';

/**
 * Columns keep their side by side layout in html exports.
 */
const createMatcher = (
  flavour: string,
  style: string
): BlockHtmlAdapterMatcher => ({
  flavour,
  toMatch: () => false,
  fromMatch: o => o.node.flavour === flavour,
  toBlockSnapshot: {},
  fromBlockSnapshot: {
    enter: (_o, context) => {
      context.walkerContext.openNode(
        {
          type: 'element',
          tagName: 'div',
          properties: { style },
          children: [],
        },
        'children'
      );
    },
    leave: (_o, context) => {
      context.walkerContext.closeNode();
    },
  },
});

export const columnsBlockHtmlAdapterMatcher = createMatcher(
  ColumnsBlockSchema.model.flavour,
  'display:flex;gap:40px;align-items:flex-start;'
);

export const columnBlockHtmlAdapterMatcher = createMatcher(
  ColumnBlockSchema.model.flavour,
  'flex:1 1 0;min-width:0;'
);

export const ColumnsBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  columnsBlockHtmlAdapterMatcher
);

export const ColumnBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  columnBlockHtmlAdapterMatcher
);
